import '../styles/tailwind.css'
import * as React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import OauthCard from './OauthCard'
import { Alert, AlertDescription } from '@/components/ui/alert'

interface IProps {
  message: string
}

const AuthorizationErrorApplication = ({ message }: IProps) => {
  return (
    <OauthCard
      maxWidthClassName="max-w-md text-center"
      title={
        <span className="flex flex-col items-center gap-3">
          <AlertTriangleIcon className="size-10 text-destructive" />
          An error has occurred
        </span>
      }
    >
      <Alert className="border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-50">
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    </OauthCard>
  )
}

export default AuthorizationErrorApplication
